const LoadingTable = ({ message = "Cargando datos...", title = "Cargando", size = "lg" }) => {
    return (
        <div className="bg-base-100 rounded-xl shadow-md shadow-primary/5 border border-base-300 p-12">
            <div className="text-center">
                <div className="w-16 h-16 bg-base-200 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className={`loading loading-dots loading-${size} text-primary`} />
                </div>
                <h3 className="text-lg font-semibold text-base-content mb-2">{title}</h3>
                <p className="text-base-content/70">{message}</p>
            </div>
        </div>
    );
};

export default LoadingTable;
